import { createAsyncThunk } from '@reduxjs/toolkit';
import { GeneratorProductsApi } from '@/Api/GeneratorProducts/GeneratorProductsApi';
import {
  CreateGeneratorProductRequest,
  CreateGeneratorProductResponse,
  GenerateUserProductResponse,
  GetGeneratorProductsResponse,
  UpdateGeneratorProductRequest,
  UpdateGeneratorProductResponse,
} from '@/Api/GeneratorProducts';
import { GetGeneratorProductsRequest } from '@/Api/GeneratorProducts/GetGeneratorProductsRequest';
import { GetProductStatusesResponse } from '@/Api/GeneratorProducts/GetProductStatusesResponse';

const getProductStatusesRequest = createAsyncThunk<GetProductStatusesResponse>(
  'generatorProducts/get-product-statuses',
  async () => {
    return GeneratorProductsApi.getProductStatuses();
  },
);

const getGeneratorProductsRequest = createAsyncThunk<GetGeneratorProductsResponse, GetGeneratorProductsRequest>(
  'generatorProducts/get-generator-products',
  async (request) => {
    return GeneratorProductsApi.getGeneratorProducts(request);
  },
);

const createGeneratorProductRequest = createAsyncThunk<CreateGeneratorProductResponse, CreateGeneratorProductRequest>(
  'generatorProducts/create-generator-product',
  async (request: CreateGeneratorProductRequest) => {
    return await GeneratorProductsApi.createGeneratorProduct(request);
  },
);

const updateGeneratorProductRequest = createAsyncThunk<UpdateGeneratorProductResponse, UpdateGeneratorProductRequest>(
  'generatorProducts/update-generator-product',
  async (request: UpdateGeneratorProductRequest) => {
    return await GeneratorProductsApi.updateGeneratorProduct(request);
  },
);

const deleteGeneratorProductRequest = createAsyncThunk<number, number>(
  'generatorProducts/delete-generator-product',
  async (id: number) => {
    return GeneratorProductsApi.deleteGeneratorProduct(id);
  },
);

const generateProductsRequest = createAsyncThunk<GenerateUserProductResponse, number>(
  'generatorProducts/generate-products',
  async (id: number) => {
    return GeneratorProductsApi.generateProducts(id);
  },
);

export const asyncActions = {
  getProductStatusesRequest,
  getGeneratorProductsRequest,
  createGeneratorProductRequest,
  updateGeneratorProductRequest,
  deleteGeneratorProductRequest,
  generateProductsRequest,
};
